"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _ListSubheader.default;
  }
});

var _ListSubheader = _interopRequireDefault(require("./ListSubheader"));


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/core/ListSubheader/index.js
// module id = 1103
// module chunks = 3